<template>
  <div id="home-dashboard">
    <div id="properties">
      <h1>Properties</h1>
      <div v-for="property in properties" :key="property.id" class="property">
        <div v-if="!properties">
          <h3>No Properties</h3>
        </div>
        <div class="property-info-left left-box">
          <h1>
            <router-link
              :to="{
                path: '/console/dashboard/property/' + property.id + '/feedback'
              }"
              >{{ property.name }}</router-link
            >
          </h1>
          <router-link
            :to="{
              path:
                '/console/dashboard/property/' +
                property.token +
                '/feedbackjscode/' +
                property.name
            }"
            >Feedback Collection Form JS Code</router-link
          ><br />
          <router-link
            :to="{
              path:
                '/console/dashboard/property/' +
                property.token +
                '/feedbackurlcode/' +
                property.name
            }"
            >Feedback Collection Form URL</router-link
          ><br />
          API Key: <span class="api-key">{{ property.token }}</span
          ><br />
        </div>
        <div class="property-info-right right-box">
          <span v-if="user.isAdmin">
            {{ property.created_date }}<br />
            <router-link
              :to="{
                path:
                  '/console/dashboard/property/' +
                  property.id +
                  '/feedback/fileupload/'
              }"
              >Upload Data</router-link
            ><br />
            <router-link
              :to="{
                path: '/console/dashboard/property/' + property.id + '/edit'
              }"
              >Edit Property</router-link
            ><br />
            <router-link
              :to="{
                path: '/console/dashboard/property/' + property.id + '/alert'
              }"
              >Manage Alerts</router-link
            ><br />
            <a href="#" @click.prevent="showDeletePropertyAlert(property.id)"
              >Delete</a
            >
          </span>
        </div>
      </div>
      <div v-if="user.isAdmin" class="center-text">
        <router-link
          to="/console/dashboard/property/create"
          tag="button"
          name="addProperty"
          class="button button-200"
          >Create Property</router-link
        >
      </div>
      <v-dialog />
    </div>
  </div>
</template>

<script>
import api from "@/api/index";
const apiServiceProperty = new api.APIServiceProperty();

export default {
  name: "DashboardHome",
  data() {
    return {
      properties: []
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  },
  created() {
    this.getProperties();
  },
  methods: {
    getProperties: function() {
      apiServiceProperty.getProperties().then(data => {
        if (data) {
          this.properties = data.data;
        }
      });
    },
    showDeletePropertyAlert: function(propertyID) {
      this.$modal.show("dialog", {
        title: "Alert!",
        text: "Do you want to delete this Property?",
        buttons: [
          {
            title: "Yes",
            handler: () => {
              this.deleteProperty(propertyID);
            }
          },
          {
            title: "", // Button title
            default: true, // Will be triggered by default if 'Enter' pressed.
            handler: () => {} // Button click handler
          },
          {
            title: "No"
          }
        ]
      });
    },
    deleteProperty: function(propertyID) {
      apiServiceProperty.deleteProperty(propertyID).then(data => {});
      this.hideDeletePropertyAlert();
      setTimeout(() => {
        this.getProperties();
      }, 2000);
    },
    hideDeletePropertyAlert: function() {
      this.$modal.hide("dialog");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
h1 {
  font-size: 24px;
  margin: 2px 0 4px 0;
}
h2 {
  font-size: 20px;
  margin-bottom: 5px;
}
h3 {
  font-size: 18px;
  margin-bottom: 0;
}
#properties {
  lost-utility: clearfix;
}
.property {
  border: 1px solid #cfe1f6;
  border-radius: 6px;
  padding: 10px 15px 15px 15px;
  lost-utility: clearfix;
  margin-bottom: 20px;
}
.property div:first-child {
  float: left;
}
.property div:last-child {
  width: 140px;
  float: right;
}
.api-key {
  font-size: 16px;
}
.left-box {
}
.right-box {
  text-align: left;
  margin-top: 10px;
}
@media (max-width: 670px) {
  .property div:first-child {
    lost-column: 1/1;
    margin-right: 0;
  }
  .property div:last-child {
    lost-column: 1/1;
    width: 100%;
    float: left;
  }
  .left-box {
  }
}
@media (max-width: 470px) {
  .api-key {
    font-size: 16px;
  }
}
</style>
